import angular from 'angular';
import teamRequestModalRemoveQuestionComponent from './teamRequestModalRemoveQuestion.component';

let teamRequestModalRemoveQuestionModule = angular.module('vacations-absences.teamRequestModalRemoveQuestion', [])

.component('teamRequestModalRemoveQuestion', teamRequestModalRemoveQuestionComponent)

.name;

export default teamRequestModalRemoveQuestionModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalRemove/teamRequestModalRemoveQuestion/teamRequestModalRemoveQuestion.js